import { render, staticRenderFns } from "./VehicleEdit.vue?vue&type=template&id=58d0664e&scoped=true"
import script from "./VehicleEdit.vue?vue&type=script&lang=js"
export * from "./VehicleEdit.vue?vue&type=script&lang=js"
import style0 from "./VehicleEdit.vue?vue&type=style&index=0&id=58d0664e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d0664e",
  null
  
)

export default component.exports